import dispatcher from "./../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "../HttpRequests/HttpRequest";
import organisationSettingConstants from "../Constants/OrganisationSettingConstants";
class OrganisationSettingActions {
  getOrganisationSettings() {
    httpRequest(
      config.webServiceURL + "/OrganisationSetting/GetOrganisationSettings",
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: organisationSettingConstants.GET_ORG_SETTING_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: organisationSettingConstants.GET_ORG_SETTING_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  SaveUpdateOrganisationSetting(settingData) {
    httpRequest(
      config.webServiceURL +
        "/OrganisationSetting/SaveUpdateOrganisationSetting",
      "POST",
      JSON.stringify({
        Name: settingData.Name,
        Value: settingData.Value,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: organisationSettingConstants.UPDATE_ORG_SETTING_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: organisationSettingConstants.UPDATE_ORG_SETTING_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  addDataOrg(orgid) {
    httpRequest(
      config.webServiceURL + "/OrganisationSetting/AddDemoData/" + orgid,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: organisationSettingConstants.ADD_ORG_DATA_SETTING_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: organisationSettingConstants.ADD_ORG_DATA_SETTING_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  partialDelOrg(orgid) {
    httpRequest(
      config.webServiceURL +
        "/OrganisationSetting/DeletePartialOrganisation/" +
        orgid,
      "DELETE",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: organisationSettingConstants.PARITAL_DEL_ORG_SETTING_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: organisationSettingConstants.PARITAL_DEL_ORG_SETTING_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  fullDelOrg(orgid) {
    httpRequest(
      config.webServiceURL +
        "/OrganisationSetting/DeleteFullOrganisation/" +
        orgid,
      "DELETE",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: organisationSettingConstants.FULL_DEL_ORG_SETTING_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: organisationSettingConstants.FULL_DEL_ORG_SETTING_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new OrganisationSettingActions();
